window.animaweb = {
    cmplz_primary: 'secondary',
    cmplz_secondary: 'light',
};